import type { Poll } from 'schema/poll';
import type { Poll as WebviewPoll } from 'schema/webview';
import { PollComponentConfig } from './PollEntrypointLoader';

export async function loadPollEntrypoint(
  poll: Pick<WebviewPoll, 'flavour' | 'template'> | Pick<Poll, 'template'>,
): Promise<PollComponentConfig> {
  if (poll.template === 'poll') return import('./entrypoints/poll/entrypoint');
  if (poll.template === 'dialog') return import('./entrypoints/dialog/entrypoint');
  if (poll.template === 'webview') {
    if ('flavour' in poll && poll.flavour === 'mobile_welcome') {
      return import('./entrypoints/webview/flavours/interests/entrypoint');
    }

    if ('flavour' in poll && poll.flavour === 'mobile_bank') {
      return import('./entrypoints/webview/flavours/mobileBank/entrypoint');
    }

    return import('./entrypoints/webview/entrypoint');
  }
  poll.template satisfies 'dialog_webview';
  return import('./entrypoints/dialogWebview/entrypoint');
}
